"use client";
import { useEffect, useState } from "react";
import { Caption } from "../../ui/typography";

/**
 * FlashTimer Component
 *
 * A countdown timer component used to display remaining time for flash sales.
 * Shows hours, minutes and seconds in a formatted display with a flash sale icon.
 *
 * @component
 * @param {Object} props
 * @param {number} [props.endTime=1] - Initial time in hours. If value is less than 1, it's treated as minutes.
 *                                      Default is 1 hour.
 *
 * @returns {JSX.Element} A styled countdown timer with flash sale branding
 *
 * @example
 * // For 2 hour countdown
 * <FlashSaleTimer endTime={2} />
 *
 * @example
 * // For 30 minute countdown
 * <FlashSaleTimer endTime={0.5} />
 */
export default function FlashSaleTimer({ endTime = 1, promotion, fixed }) {
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
  const [timeRemaining, setTimeRemaining] = useState("");

  useEffect(() => {
    const targetTime = new Date(endTime).getTime();

    const updateTimer = () => {
      const now = new Date().getTime();
      const distance = targetTime - now;

      if (distance <= 0) {
        setTimeRemaining("Sale has ended");
        setTimeout(() => {
          setTimeRemaining("Closed");
          clearInterval(intervalId);
          return;
        }, 1000);
      }

      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);
      setTimeLeft({
        hours: hours,
        minutes: minutes,
        seconds: seconds,
      });
    };

    const intervalId = setInterval(updateTimer, 1000);

    // Clean up the interval on component unmount
    return () => clearInterval(intervalId);
  }, [endTime]);
  // Add leading zeros
  const padNumber = num => String(num).padStart(2, "0");

  return (
    <>
      {timeRemaining == "Closed" ? (
        ""
      ) : (
        <>
          <Caption
            className={`bg-system-sky text-center lg:border-t border-midnightIndigo-200 text-midnightIndigo-400 p-[7px] truncate text-nowrap ${
              promotion ? "block" : "hidden"
            }   ${!fixed ? "block animate__animated animate__fadeIn" : "animate__animated animate__fadeOut hidden "}`}
          >
            {timeRemaining == "Sale has ended" ? (
              "Sale has ended"
            ) : (
              <>
                ⚡️ Flash Sale! Ends in <span>{padNumber(timeLeft.hours)}h</span> :
                <span>{padNumber(timeLeft.minutes)}m</span> :<span>{padNumber(timeLeft.seconds)}s</span> | Shop now
              </>
            )}{" "}
          </Caption>
        </>
      )}
    </>
  );
}
